import { http } from '@/utils/http';
import qs from 'qs';
export function vote(
  voteName: string,
  data: {
    id: number | string;
    udid?: any;
    appkey?: any;
    code?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
    type?: string | number;
  },
) {
  const qsData = qs.stringify(data);
  return http.post('/vote/' + voteName + '/controller.php?enews=vote', qsData);
}
